export enum ChecklistEntryDateTimeType {
  RELATIVE = 'RELATIVE',
  ABSOLUTE = 'ABSOLUTE',
}
